Vendd.Scripts.load(function () {
    if ($('.back-to-top').length > 0) {
        backToTop();
    }

    if (isTouch()) {
        initFooterMenuToggle();
    }
    //var hostname = window.location.hostname;

    //var isHomemarktEnvironment =
    //    hostname === 'homemarktnew2018.test.devlh.com' ||
    //    hostname === 'local.homemarktnew2018.gr' ||
    //    hostname == "homemarktnew2018.staginglh.com";
    //if (isHomemarktEnvironment) {
    //    document.querySelectorAll('.newsletter-container img, .newsletter-container source').forEach((img) => {
    //        ['src', 'srcset', 'data-src', 'data-srcset'].forEach((attr) => {
    //            const value = img.getAttribute(attr);

    //            if (value) {
    //                img.setAttribute(
    //                    attr,
    //                    value.replace(/\/\/homemarkt\.lhscdn\.com/g, '//homemarktnew2018.test.devlh.com')
    //                );
    //            }
    //        });
    //    });
    //}
});

function backToTop() {
    var $backToTop = $(".back-to-top"),
    scroll;

    scroll = $(window).scrollTop();
    scroll > 500 ? $backToTop.addClass("visible") : $backToTop.removeClass("visible");
    $(window).scroll($.debounce(200, function () {
        scroll = $(window).scrollTop();
        scroll > 500 ? $backToTop.addClass("visible") : $backToTop.removeClass("visible")
    }));

    $backToTop.on("click", function () {
        $("body,html").animate({ scrollTop: 0 }, 400, 'swing');
    });
}

function initFooterMenuToggle() {
    var mainCont = $('.footer-template-one .region-area-two');
    $(".footer-template-one .js-toggle").click(function () {
        var hiddenCont = $(this).siblings('.js-content-accord');
        $(this).find('.text').toggleClass('icon-arrow-down icon-arrow-up');
        if (hiddenCont.hasClass('opened')) {
            hiddenCont.removeClass('opened');
        } else {
            mainCont.find('.opened').removeClass('opened').siblings('.js-toggle').find('.text').toggleClass('icon-arrow-down icon-arrow-up');
            hiddenCont.addClass('opened');
        }
        console.log($('.js-content-accord', mainCont).siblings('.js-toggle').find('.text'))
    });

    var accordion = false;

    if ($(window).outerWidth() <= 767) {
        accordion = true;
    }

    $(window).resize(function () {
        if ($(window).outerWidth() > 767) {
            if (accordion) {
                $('.js-content-accord', mainCont).removeClass('opened');
                accordion = false;
            }
        }
        else {
            if (!accordion) {
                $('.js-content-accord', mainCont).siblings('.js-toggle').find('.text').addClass('icon-arrow-down').removeClass('icon-arrow-up');
                accordion = true;
            }
        }
    });
}